export default function calculatePercentage(partialValue, totalValue) {
  return (100 * partialValue) / totalValue;
}
